import { render } from "./CreateUpdateAccount.vue?vue&type=template&id=7c34ef8c&scoped=true&ts=true"
import script from "./CreateUpdateAccount.vue?vue&type=script&lang=ts"
export * from "./CreateUpdateAccount.vue?vue&type=script&lang=ts"

import "./CreateUpdateAccount.vue?vue&type=style&index=0&id=7c34ef8c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c34ef8c"]])

export default __exports__